export default "__VITE_ASSET__ae128d5f__$_?nuxt_component=async__"